import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { LanguageService } from '../services/language.service';

@Injectable()
export class InternationalizationInterceptor implements HttpInterceptor {
    //public inter: InternationalizationService;

    constructor(private language: LanguageService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req.clone({
            headers: req.headers
                .set('Accept-Language', this.language.current().code)
                .set('Content-Language', this.language.current().code)
        }));
    }
}